/*

IMPORTANT:

Ajax requests that update Shopify's cart must be queued and sent synchronously to the server.
Meaning: you must wait for your 1st ajax callback to send your 2nd request, and then wait
for its callback to send your 3rd request, etc.

	16 Oct 2013 - Added support for Line Item parameters in /cart/add
	3 Dec 2014 - Renamed to tcr-shopify-api and stripped out unused stuff
    15 Dec - removed sync on attribute update
    23 Dec - Added functions from cart-extensions and add-to-cart
    8 March - renamed
    11 April - hid basket if empty
    1.1 - 29 May - Updated User Error message
*/
TCR.shopify = (function() {
  LTK.logHide.push( 'TCR.shopify' );	// Hide all these log messages
  
    // EXTERNAL functions called
  function log(text) { TCR.log(text); };
  function info(text) { TCR.info(text); };
  function warning(text) { TCR.warning(text); };
  function error(text) { TCR.error(text); throw(text); };
  function message(text) { TCR.message(text); };
  function closeMessage() { TCR.closeMessage(); };
  function isBlank( obj ) { return LTK.isBlank( obj ); };
  function notBlank( obj ) { return LTK.notBlank( obj ); };
  function buildIconBlock( icon_file, icon_text, text_class ) {
    return TCR.buildIconBlock( icon_file, icon_text, text_class );
  };

  // Events
  var CART_AVAILABLE = "cartavailable";		// The Cart has been retreived
  var NEXT_ACTION = "nextaction";			// Ready to run the next queued Action (AJAX or other function)
  var ACTION_QUEUE_EMPTY = "actionqueueempty";	// The Action Queue is empty - fired when last queued action completes

  // GLOBALS
  var MOD = "TCR.shopify.";
  var ACTION_QUEUE = [];
  var CURRENT_ACTION = {};	// The Action item that is currently running
  var CURRENT_CART = {};
  var USER_ERROR_MESSAGE = "Sorry, something went wrong. We have been notified of the problem.<br/>" +
      "You could retry your last action or reload the page.";
  var CART_SUMMARY_ELEMENT = ".cart-summary";	// Cart icon & # of items. a[href='/cart']
  var cart_icon = 'shopping-bag_small.png';
  var CART_IMG = '<img class="icon" src="' + Shopify.ASSET_URL.replace( 'abc?', cart_icon + '?') + '"/>'
  
  //log( MOD + "JS..." );

  function attributeToString(attribute) {
    if ((typeof attribute) !== 'string') {
      // Converts to a string.
      attribute += '';
      if (attribute === 'undefined') {
        attribute = '';
      }
    }
    // Removing leading and trailing whitespace.
    return jQuery.trim( encodeURIComponent(attribute) );
  };

  function fullMessagesFromErrors(errors) {
    var fullMessages = [];
    jQuery.each(errors, function(attribute, messages) {
      jQuery.each(messages, function(index, message) {
        fullMessages.push(attribute + ' ' + message);
      });
    });
    return fullMessages
  };

  /*
	Action Queue functions
*/

  function queue(request) {
    var fn = MOD + "queue() ";
    //log( fn + "..." );

    ACTION_QUEUE.push(request);
    log( fn + request.type + ":" + request.title + "(" + ACTION_QUEUE.length + " in queue)" );
    if ( isBlank( CURRENT_ACTION ) ) { // Nothing being processed
      //log( fn + "Trigger:NEXT_ACTION: Start processing Action Queue");
      $( "body" ).trigger( NEXT_ACTION );
    }
  };

  // isCartAction = return TRUE if supplied action will return the cart
  //	NOTE: /cart/add.js will add to cart but return item not cart

  function isCartAction( action ) {
    var fn = MOD + "isCartAction() ";

    if ( isBlank( action ) ) {
      warning( fn + "...Action is BLANK");
      return false;
    }

    switch ( action.url ) {
      case '/cart/change.js':
      case '/cart/update.js':
      case '/cart/clear.js':
      case '/cart.js':
        //log( fn + "...TRUE");
        return true;
    }
    //log( fn + "...FALSE");
    return false;
  };

  // isAJAXAction - return TRUE if supplied aciont is an AJAX action
  function isAJAXAction( action ) {
    var fn = MOD + "isAJAXAction() ";

    if ( isBlank ( action.type ) ) {
      error( fn + "Null Type for Action: " + JSON.stringify( action ) );
      return false;
    }
    switch ( action.type ) {
      case 'POST':
      case 'GET':
      case 'PUT':
        //log( fn + "...TRUE" );
        return true;
        break;
      default:
        //log( fn + "...FALSE" );
        return false;
    }
  };

  // isNormalAction - return TRUE if supplied action is a normal action with a function
  function isNormalAction( action ) {
    var fn = MOD + "isNormalAction() ";

    if ( isBlank( action.type ) ) {
      error( fn + "Null Type for Action:" + JSON.stringify( action ) );
      return false;
    }
    if ( action.type == "ACTION" ) {
      if ( (typeof action.fn) === 'function' ) {
        //log( fn + "...TRUE" );
        return true;
      } else {
        error( fn + "No function specified for Action: " + JSON.stringify( action ) );
        return false;
      }
    } else {
      //log( fn + "...FALSE" );
      return false;
    }
  };
  
    //	itemIsDeliveryProduct() - Return TRUE if item is a delivery product

  function itemIsDeliveryProduct(cart_item) {
    var fn = MOD + "itemIsDeliveryProduct() ";
    var return_value = false;

    //log("isDeliveryProduct: " + LTK.objectAttributes(cart_item));
    return_value = cart_item.handle.indexOf("delivery") >= 0 ? true : false;
    //log(fn + "..." + cart_item.handle + ": " + return_value);
    return return_value;
  };


  /*
  Default API call backs - normally overidded
  */

  function onError(XMLHttpRequest, textStatus) {
    // Shopify returns a description of the error in XMLHttpRequest.responseText.
    // It is JSON.
    // Example: {"description":"The product 'Amelia - Small' is already sold out.","status":500,"message":"Cart Error"}
    //console.log( "XMLHttpRequest: " + LTK.objectAttributes( XMLHttpRequest ) + ", textStatus: " + textStatus );
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if ( isBlank( data ) ) {
      error("Error from Shopify AJAX: " + LTK.objectAttributes( XMLHttpRequest ));
    } else if (!!data.message) {
      message( "Opps: " + data.description );
      error(data.message + '(' + data.status  + '): ' + data.description);
    } else {
      error('Error : ' + fullMessagesFromErrors(data).join('; ') + '.');
    }
  };

  function onCartUpdate(cart) {
    //log('There are now ' + cart.item_count + ' items in the cart.');
  };

  function onItemAdded(line_item) {
    //log(line_item.title + ' was added to shopping cart.');
    // Should we get the cart and save it?
  };

  function onProduct(product) {
    //log('Received product: ' + product.title);
  };
  
  function saveCart( cart ) {
    var fn = MOD + "saveCart() ";
    //log( fn + "..." );
    CURRENT_CART = cart;
    
    // Update Cart Icon with number of items
    var cart_text;
    var num_coffees = 0;
    var num_deliveries = 0;
    
    jQuery.each( cart.items, function(key, item) {
      if ( itemIsDeliveryProduct( item ) ) {
        num_deliveries += 1;
      }
      else {
        num_coffees += 1;
      }
    });
    
    switch ( num_coffees ) {
      case 0:
        cart_text="Empty";
        break;
      case 1:
        cart_text= "1 coffee";
        break;
      default:
        cart_text = num_coffees + " coffees";
    };
    if ( num_coffees > 0 ) {
      switch ( num_deliveries ) {
        case 0:
          cart_text += "<br/>+ delivery";
          break;
        case 1:
          //cart_text += "<br/>1 delivery";
          break;
        default:
          //cart_text += "<br/>" + num_deliveries + " deliveries";
      };

      jQuery( CART_SUMMARY_ELEMENT).html(
        buildIconBlock( CART_IMG, cart_text, "" )
      );
    }
    

    $( "body" ).trigger( CART_AVAILABLE, [ CURRENT_CART ] );
    log( fn + "...SAVED. Triggered CART_AVAILABLE" );
  };



  // ---------------------------------------------------------
  // queueAjax - AJAX POST to Shopify for Cart or Products. Returns the data in JSON.
  // ---------------------------------------------------------

  function queueAjax( params, callback ) {
    var fn = MOD + "queueAjax() " + params.title + " ";
    //log( fn + "..." );

    var default_callback;

    switch ( params.url ) {
      case '/cart/add.js':
        default_callback = onItemAdded;
        break;
      case '/cart/change.js':
      case '/cart/update.js':
      case '/cart/clear.js':
      case '/cart.js':
        default_callback = onCartUpdate;
        break;
      default:
        if ( params.url.indexOf("/products/") >= 0 ) {
          default_callback = onProduct;
        } else {
          error( fn + "Invalid URL provided: " + params.url )
          return false;
        }
    }

    var ajaxParams = {
      type: 'POST',
      dataType: 'json',
      success: function( obj ) {

        try {
          log( fn + "- SUCCESS" );
          //info( fn + "obj: " + JSON.stringify( obj ) );
          if ( isCartAction ( this ) ){
            //log( fn + "- saving returned cart" );
            //log( fn + "- CART: " + JSON.stringify( obj ) );
            saveCart( obj );
          };
          if ((typeof callback) === 'function') {
            //log( fn + "- calling callback()...");
            callback( obj );
          }
          else {
            //log( fn + "calling default_callback()");
            default_callback( obj )
          }
          //log( fn + "Trigger:NEXT_ACTION: after callback()");
          $( "body" ).trigger( NEXT_ACTION );
        } catch(err) {
          warning(fn + "ERROR: " + err + ", JSON:" + JSON.stringify( err ));
          message( USER_ERROR_MESSAGE );
        };
      },
      error: function(XMLHttpRequest, textStatus) {
        warning( fn + "- ERROR" );
        onError(XMLHttpRequest, textStatus);
        
        // This wont happen onError doesn't return
        warning( fn + "Trigger:NEXT_ACTION: AJAX error");
        $( "body" ).trigger( NEXT_ACTION );
      }
    };
    //log( fn + " Callback: " + callback );
    for( var attr in params ) { ajaxParams[attr] = params[attr]; }

    //	Add request to AJAX Queue
    queue( ajaxParams );
    //log( fn + "...OK" );
  };


  var queueAction = function( request, callback ) {
    var fn = MOD + "queueAction() ";
    //log( fn + "..." );

    var actionRequest = {
      type: 'ACTION',
      fn: null		// This must be the action function
    };

    for( var attr in request ) { actionRequest[attr] = request[attr]; }

    //	Add request to Queue
    queue( actionRequest );
    //log( fn + "...OK" );
  };

  var cartIsNull = function() {
    return isBlank( CURRENT_CART );
  };

  


  //	cartRequestQueued - return TRUE if a request that will change the Cart is currently queued or in progress
  var cartRequestQueued = function() {
    if ( notBlank( CURRENT_ACTION ) && 
        isCartAction( CURRENT_ACTION ) ) return true;

    for ( var i = 0; i < ACTION_QUEUE.length; i++ ) {
      if ( isCartAction( ACTION_QUEUE[ i ] ) ) return true;
    }
    return false;
  };

  var cartIsEmpty = function() {
    var fn = MOD + "cartIsEmpty() ";
    if ( cartIsNull() ) return true;

	//log( fn + CURRENT_CART.item_count + " items" );    
    return ( CURRENT_CART.item_count < 1);
  };

  // -------------------------------------------------------------------------------------
  // POST to cart/add.js returns the JSON of the line item associated with the added item.
  //      variant_id
  //      quantity
  //      properties - Array or Hash
  // -------------------------------------------------------------------------------------
  var _addItem = function(variant_id, quantity, properties, callback) {
    var fn = MOD + "_addItem() ";
    //log( fn + "..." );

    var quantity = quantity || 1;
    var data = 'quantity=' + quantity + '&id=' + variant_id;
    // If properties is an array of the form:
    // [ { key: 'my key', value: 'my value' }, ... ]
    if (jQuery.isArray(properties)) {
      jQuery.each(properties, function(indexInArray, valueOfElement) {
        var key = attributeToString(valueOfElement.key);
        if (key !== '') {
          data += '&properties[' + key + ']=' + attributeToString(valueOfElement.value);
        }
      });
    }
    // If properties is a hash of the form:
    // { 'my key' : 'my value', ... }
    else if ((typeof properties === 'object') && properties !== null) {
      jQuery.each(properties, function(key, value) {
        data += '&properties[' + attributeToString(key) + ']=' + attributeToString(value);
      });
    }

    var params = {
      title: "Add Cart Item",
      url: '/cart/add.js',
      data: data
    };
    queueAjax( params, callback );
    //log( fn + "...Queued" );
  };
  function addCartItem(variant_id, quantity, callback) {
    _addItem(variant_id, quantity, "", callback)
  }
  function addCartItemWithProperties(variant_id, quantity, properties, callback) {
    _addItem(variant_id, quantity, properties, callback)
  }

  // ---------------------------------------------------------
  // POST to cart/add.js returns the JSON of the line item.
  // ---------------------------------------------------------
  var addCartItemFromForm = function(form_id, callback) {
    var fn = MOD + "addCartItemFromForm() ";
    //log( fn + "..." );

    var params = {
      title: "Add Cart Item from Form",
      url: '/cart/add.js',
      data: jQuery('#' + form_id).serialize()
    };
    queueAjax( params, callback );
    //log( fn + "...Queued" );
  };

  // ---------------------------------------------------------
  // getCart - Return the current cart or request one. Must specify callback
  // getShopifyCart - Really get the cart from Shopify
  // ---------------------------------------------------------
  function getShopifyCart( callback ) {
    var fn = MOD + "getShopifyCart() ";

    //log( fn + "..." );
    var params = {
      title: "Get Cart from Shopify",
      type: 'GET',
      url: '/cart.js'
    };
    queueAjax( params, callback );
    //log( fn + "...Queued" );
  };
  
  
  function getCart( callback ) {
    var fn = MOD + "getCart() ";

    //log( fn + "..." );

    if ( (typeof callback) != 'function' ) {
      error( fn + "Callback function is not specified or invalid" );
      return false;
    }

    if ( notBlank( CURRENT_CART ) ) {
      //log( fn + "...CURRENT CART: " + CURRENT_CART.item_count + " items" );
      callback( CURRENT_CART );

    } else if ( cartRequestQueued() ) { // No cart but get request queued - return cart at end of queue
      //log( fn + "...NO CART but queued" );

      var actionRequest = {
        title: "Get Cart action",
        fn: function() {
          callback ( CURRENT_CART );
        }
      };

      queueAction( actionRequest, callback );
      //log( fn + "...Queued" );

    } else {		// No cart and nothing queued so get cart ourselves
      getShopifyCart( callback );
    }
    return true;
  };

  // ---------------------------------------------------------
  // GET products/<product-handle>.js returns the product in JSON.
  // ---------------------------------------------------------
  function getProduct(handle, callback) {
    var fn = MOD + "getProduct() ";
    //log( fn + "..." );

    var params = {
      title: "Get Product",
      type: 'GET',
      url: '/products/' + handle + '.js'
    };
    queueAjax( params, callback );
    //log( fn + "...Queued" );

  };

  // ---------------------------------------------------------
  // POST to cart/change.js returns the cart in JSON.
  // ---------------------------------------------------------
  var changeCartItem = function(variant_id, quantity, callback) {
    var fn = MOD + "changeCartItem() ";
    //log( fn + "..." );

    var params = {
      title: "Change Cart Item",
      url: '/cart/change.js',
      data:  'quantity='+quantity+'&id='+variant_id
    };
    queueAjax( params, callback );
    //log( fn + "...Queued" );

  };

  // ---------------------------------------------------------
  // POST to cart/change.js returns the cart in JSON.
  // ---------------------------------------------------------
  var removeCartItem = function(variant_id, callback) {
    var fn = MOD + "removeCartItem() ";
    //log( fn + "..." );

    var params = {
      title: "Remove Cart Item",
      url: '/cart/change.js',
      data:  'quantity=0&id='+variant_id
    };
    queueAjax( params, callback );
    //log( fn + "...Queued" );
  };

  // ---------------------------------------------------------
  // clearCart( callback( cart ) )
  // It removes all the items in the cart, but does
  // not clear the cart attributes nor the cart note.
  // ---------------------------------------------------------
  var clearCart = function(callback) {
    var fn = MOD + "clearCart() ";
    log( fn + "..." );

    var params = {
      title: "Clear Cart",
      url: '/cart/clear.js',
      data:  ''
    };
    queueAjax( params, callback );
    //log( fn + "...Queued" );
  };

  // ---------------------------------------------------------
  // updateCartFromForm( form_id, callback( cart ) )
  // ---------------------------------------------------------

  var updateCartFromForm = function(form_id, callback) {
    var fn = MOD + "updateCartFromForm() ";
    //log( fn + "..." );

    var params = {
      title: "Update Cart from Form",
      url: '/cart/update.js',
      data: jQuery('#' + form_id).serialize()
    };
    queueAjax( params, callback );
    //log( fn + "...Queued" );
  };


  // ---------------------------------------------------------
  // POST to cart/update.js returns the cart in JSON.
  // To clear a particular attribute, set its value to an empty string.
  // Receives attributes as a hash or array. Look at comments below.
  // ---------------------------------------------------------

  var updateCartAttributes = function(attributes, callback) {
    var fn = MOD + "updateCartAttributes() ";
    //log( fn + "..." );

    var data = '';
    // If attributes is an array of the form:
    // [ { key: 'my key', value: 'my value' }, ... ]
    if (jQuery.isArray(attributes)) {
      jQuery.each(attributes, function(indexInArray, valueOfElement) {
        var key = attributeToString(valueOfElement.key);
        if (key !== '') {
          data += 'attributes[' + key + ']=' + attributeToString(valueOfElement.value) + '&';
        }
      });
    }
    // If attributes is a hash of the form:
    // { 'my key' : 'my value', ... }
    else if ((typeof attributes === 'object') && attributes !== null) {
      jQuery.each(attributes, function(key, value) {
        data += 'attributes[' + attributeToString(key) + ']=' + attributeToString(value) + '&';
      });
    }
    //log( fn + "Data: " + data );
    var params = {
      title: "Update Cart Attributes",
      url: '/cart/update.js',
      data: data
    };
    queueAjax( params, callback );
    //log( fn + "...Queued" );
  };

  // ---------------------------------------------------------
  // POST to cart/update.js returns the cart in JSON.
  // ---------------------------------------------------------
  var updateCartNote = function(note, callback) {
    var fn = MOD + "updateCartNote() ";
    //log( fn + "..." );

    var params = {
      title: "Update Cart Note",
      url: '/cart/update.js',
      data: 'note=' + attributeToString(note)
    };
    queueAjax( params, callback );
    //log( fn + "...Queued" );
  };

  /*
	Shopify - additional JS functions and data for interacting with Shopify

Contents:
	MAIN - get the cart and trigger event when ready
    cart - current cart
    cartIsNull - cart has not been received yet
    cartIsEmpty - have got the cart but no items in it
	getCartAttributes - return current cart attributes as an object
	cartProperties - return current cart properties

    cart should be set to null befoer we get a new one

*/
  
  function getCartAttributes( callback ) {
    var fn = MOD + "getCartAttributes() ";
    getCart( function( cart ) {
      callback( cart.attributes );
    });
  }

/*
	clearCartAttributes() - Clear all attributes
*/
  function clearCartAttributes( callback ) {
    var fn = MOD + "clearCartAttributes() ";

    log( fn + "...");
    if ( cartIsNull() ) return {};
    
    getCartAttributes( function( cart_attributes ) {
      var attributes = [];
      jQuery.each( cart_attributes, function(key, value) {
        attributes.push({ key: key, value: "" });
      });
      //log( fn + "Attributes: " + JSON.stringify( attributes ) );
      updateCartAttributes( attributes, function( cart ) {
        //console.log( "clear returned" );
        //log( fn + "...OK");
      });
    });

  };


  var showQueue = function() {
    var fn = MOD + "showQueue() ";

    if ( notBlank ( CURRENT_ACTION ) ) {
      //log( fn + "CURRENT Action: " + 
      //        CURRENT_ACTION.title + " - " + JSON.stringify( CURRENT_ACTION ) ); 

    }
    //log( fn + "Action Queue: " + ACTION_QUEUE.length + " items");
    jQuery.each(ACTION_QUEUE, function(key, item) {
      //log( fn + "QUEUED Action: " + key + ":" +
              //item.title + " - " + JSON.stringify( item ) ); 
    });
    //log( fn + "Action Queue END");
  }

  var clearQueue = function() {
    var fn = MOD + "clearQueue() ";

    ACTION_QUEUE = [];
    CURRENT_ACTION = {};
    //info( fn + "Trigger:ACTION_QUEUE_EMPTY");
    $( "body" ).trigger( ACTION_QUEUE_EMPTY );
    //log(fn + "Action Queue cleared");
  }

  /*
	Event - NEXT_ACTION - process the next request in the Action Queue
    Modifies globals: ACTION_QUEUE & CURRENT_ACTION
  */
  $( "body" ).on( NEXT_ACTION, function( event ) {
    var fn = MOD + "EVENT:NEXT ACTION: "
    try {

      if ( ACTION_QUEUE.length > 0 ) {
        //log( fn + 'Queue Length: ' + ACTION_QUEUE.length);
        CURRENT_ACTION = ACTION_QUEUE.shift();		// Get the next action

        if ( isNormalAction(CURRENT_ACTION) ) {

          // Normal Action - just call the function then trigger event when returns
          //log( fn + "Calling ACTION: " + JSON.stringify( CURRENT_ACTION ) );
          CURRENT_ACTION.fn( CURRENT_ACTION );

          //log( fn + "Trigger:NEXT_ACTION: after normal action");
          $( "body" ).trigger( NEXT_ACTION ); // parameters needs to be an array

        } else if ( isAJAXAction(CURRENT_ACTION) ) {
          //log( fn + "AJAX: " + JSON.stringify( CURRENT_ACTION ) );
          jQuery.ajax( CURRENT_ACTION );

        } else {
          error( fn + "Trigger:NEXT_ACTION: Invalid Action: " + JSON.stringify( CURRENT_ACTION ) );
          $( "body" ).trigger( NEXT_ACTION );
        }

      } else {	// ACTION_QUEUE is EMPTY
        //log( fn + 'EMPTY Queue - nothing to do. Trigger Queue Empty');
        CURRENT_ACTION = {};
        $( "body" ).trigger( ACTION_QUEUE_EMPTY );
      }
      //log( fn + "...OK" );
    } catch(err) {
      warning(fn + "ERROR: " + err + ", JSON:" + JSON.stringify( err ));
      message( USER_ERROR_MESSAGE );
    };

  });

  /*
	MAIN
  */
  var main = function() {
    var fn = MOD + "main() ";

    //log( fn + "...");

    CURRENT_CART = {};
    if( Shopify.template != 'cart' ) {	// cart template gets its own cart
      getCart( function( cart ) {
        //log( fn + "Got cart...OK - " +
            //cart.items.length + ' Line Items (' + cart.item_count + ' items)');
      });
    }
    //log( fn + "...OK");
  };

  main();


  //log( MOD + "JS...OK")
  //	Public methods

  return {
    action_queue_empty: ACTION_QUEUE_EMPTY,
    next_action: NEXT_ACTION,
    addCartItem: addCartItem,
    addCartItemWithProperties: addCartItemWithProperties,
    addCartItemFromForm: addCartItemFromForm,
    cart_available: CART_AVAILABLE,
    cartIsEmpty: cartIsEmpty,
    cartIsNull: cartIsNull,
    changeCartItem: changeCartItem,
    clearCart: clearCart,
    clearCartAttributes: clearCartAttributes,
    getCart: getCart,
    getShopifyCart: getShopifyCart,
    getCartAttributes: getCartAttributes,
    getProduct: getProduct,
    itemIsDeliveryProduct: itemIsDeliveryProduct,
    queueAction: queueAction,
    removeCartItem: removeCartItem,
    updateCartAttributes: updateCartAttributes,
    updateCartFromForm: updateCartFromForm,
    updateCartNote: updateCartNote
  };

})();	// End of TCR.shopify Module - IFFE pattern

